"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_infographic__or__pie__chart__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "bf0a2bcc-8eaf-4d2d-aff7-12be3e77324f",
    "data-name": "Infographics_ic_hi",
    viewBox: "0 0 191.5 191.5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "d507227e-3506-4b3c-b407-d95f1f171630",
    "data-name": "Bounding Box",
    points: "0 191.5 0 0 191.5 0 191.5 191.5 0 191.5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,95.84,167,132.12a79.88,79.88,0,0,1-14.7,20.23L95.71,95.84",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,95.84l56.54,56.5A79.88,79.88,0,0,0,167,132.12L95.71,95.84",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,95.84l79.36-9.74a76,76,0,0,1-8.12,46Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,95.84,116.4,18.65C148.86,27.34,171,52.77,175.07,86.1Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,95.84l56.54,56.51a79.93,79.93,0,0,1-113.08-113C60,18.55,88,11,116.4,18.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,173.87a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,95.75,173.87Z",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("title", null, "infographic-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "b12872f0-b1f6-4ad4-b18d-9a52403ef390",
    "data-name": "Infographic_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "fc7be0e5-4b58-49d6-b582-4a184a93ed74",
    "data-name": "Infographics_ic_hi",
    width: 191.5,
    height: 191.5,
    transform: "translate(0.25 0.25)",
    xlinkHref: "#bf0a2bcc-8eaf-4d2d-aff7-12be3e77324f"
  })));
}

var _default = ic_infographic__or__pie__chart__dark;
exports.default = _default;